/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {unlinkAllInstrumentLinks} from '../api'

export const useMutationUnlinkAllInstrumentLinks = createReactQueryMutationHook('unlinkAllInstrumentLinks', unlinkAllInstrumentLinks)
